import {createSlice} from '@reduxjs/toolkit';

export const initialState = {
  pharmacyData :[],
  pharmacyLabel:[]
};
export const dataReducer = createSlice({
  name: 'pharmacyData',
  initialState,
  reducers: {
    setPharmacyData: (state, {payload}) => {
      state.pharmacyData = payload;
    },
    setPharmacyLabel: (state, {payload}) => {
      state.pharmacyLabel = payload;
    },
  },
});


export const {setPharmacyData, setPharmacyLabel} = dataReducer.actions;

export default dataReducer.reducer;
